export { default } from "./CameraPermissionDenied";
